export { API_ND_AREA } from '../constants';
export const NAME = 'AbcFmsAnalysis';
export const CRUMB_LABEL_KEY = 'AbcFmsAnalysis';
export const ABC_FMS_ANALYSIS = 'AbcFmsAnalysis';
export const API_NAME = 'AbcFmsAnalysis';
export const EXPORT_FILE_NAME='AbcFmsAnalysis.xlsx';